export default function () {
  const observer = lozad('.lozad', {
    threshold: 0.1,
  });

  observer.observe();
};
